module.exports = __webpack_public_path__ + "static/media/AboutUs.db8e2f03.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Misc/Contents/AboutUs.md
// module id = 954
// module chunks = 0